import React, { useEffect, useState, useCallback, useMemo, useContext } from "react";
import axios from "axios";

import "./guide.css"
import "./detail.css";
import "./subcategory.css"
import { BaseSubcategoryData, Content, LikesData } from "./globalType";
import { getHost } from "./utils";
import { Popup } from "./components/popup";
import { likeContent } from "./api";
import { AuthContext } from "./auth";
import { SubcategoryTopMenu } from "./components/topMenu";
import { TailSpin } from "react-loader-spinner";

declare var $: any;

type SubcatProps = {
  goToPage: (page: string, content: Content | null) => void;
  shelfSlug: string;
};

function Subcategory(props: SubcatProps) {
  const { goToPage, shelfSlug } = props;
  const [popup, setPopup] = useState<Content | null>(null);
  const [likesData, setLikesData] = useState<LikesData | null>(null)
  const [baseShelf, setBaseShelf] = useState<BaseSubcategoryData | null>(null)
  const [currentSlug, setCurrentSlug] = useState<string | undefined>(undefined);
  const [isLoading, setLoading] = useState<boolean>(false)

  const authContext = useContext(AuthContext);
  
  if (currentSlug !== shelfSlug) {
    setCurrentSlug(shelfSlug);
    setBaseShelf(null)
  }

  useEffect(() => {
    if (shelfSlug && currentSlug) {
      fetchContents(shelfSlug);
    }
  }, [currentSlug]);


  const fetchContents = async (slug:string) => {
    try {
      const result = await fetchShelf(slug);
      setBaseShelf(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handlePopupVideoMouseLeave = useMemo(
    () => () => {
      $(".popupVideo>.detail").hide();
    },
    []
  );

  const handleClickLoadmore = () => {
    if (baseShelf) {
      fetchLoadmore(shelfSlug, baseShelf.pages.cursor);
    }
  }

  const fetchLoadmore = async (slug:string, cursor:string) => {
    try {
      if (baseShelf) {
        setLoading(true)
        const result = await fetchLoadmoreContents(slug, cursor);
        const list = [...baseShelf.contents, ...result.data.contents]
        setBaseShelf({
          ...result.data,
          contents: list,
        });
      }
      
    } catch (error) {
      console.log(error);
    }
    setLoading(false)
  }

  const likes = async (contentId:string | undefined) => {
    if (!contentId) return;
    if (likesData && likesData[contentId]) {
      setLikesData({
        ...likesData,
        [contentId]: false,
      })
      return;
    }
    const result = await likeContent(contentId, authContext?.user?.profile.access_token)
    if (!result) return;

    setLikesData({
      ...likesData,
      [contentId]: true,
    })
  }

  return (
    <>
      {!baseShelf && (
        <div className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
        <TailSpin color="#00BFFF" height={150} width={150} />
        </div>
      )}

      <SubcategoryTopMenu goToPage={goToPage} page={shelfSlug ? shelfSlug: 'foryou'} menu={baseShelf?.menu ? baseShelf.menu: []} />

      {baseShelf && baseShelf?.contents.length > 0 && (
        <div className="main-container w-100">
          <div className="main">
            {baseShelf?.contents.map((item, index) => (
              <CarouselItem
              goToPage={goToPage}
                key={item.id}
                content={item}
                setPopup={setPopup}
                viewType="poster"
                index={index}
              />
            ))}
          </div>
        </div>
      )}
      {baseShelf && baseShelf.pages.cursor && !isLoading && (
        <div className="text-center mt-3">
          <button onClick={handleClickLoadmore} className="loadmore-BT bold">
              Load More +
          </button>
      </div>
      )}
      
      <Popup popup={popup} goToPage={goToPage} likes={likes} likesData={likesData} />
    </>
  );
}


interface CarouselItemProps {
  content: Content;
  setPopup: React.Dispatch<React.SetStateAction<Content | null>>;
  viewType: string;
  index: number;
  goToPage: (page: string, content: Content | null) => void;
}
export function CarouselItem(props: CarouselItemProps) {
  const { content, setPopup, viewType, goToPage } = props;
  const handlePopupChange = useCallback(() => {
    setPopup(content);
  }, [content, setPopup]);

  const w_device = $(window).width();

  const handleImageMouseEnter = useMemo(
    () => (evt: React.MouseEvent) => {
      handlePopupChange();
      
      let w = $(evt.target).width();
      let h = $(evt.target).height();
      let pos = $(evt.target).offset();
      let l = pos.left + w / 2 < 160 ? 160 : pos.left + w / 2;
      let per_min = (pos.left / w_device) * 100;
      let per_max = (l / w_device) * 100;

      if (per_max > 20 && per_min < 12) l = "220px";

      if ($(evt.target).attr("landscape")) {
        if (per_max > 70) {
          l = "81vw";
        }
      }

      $(".popupVideo").css({
        top: pos.top + h / 2,
        left: l,
      });

      $(".popupVideo>.detail").css({
        width: `${w * 1.1 > 360 ? w * 1.1 : 360}px`,

        height: `${h * 1.1 > 380 ? w * 1.1 : 380}px`,
      });

      if (per_max < 20 && per_min < 12) {
        $(".popupVideo").css({
          top: pos.top + h / 2,
          left: 360/2 + w_device * 0.04,
          right: "auto",
          width: `${w * 1.1 > 360 ? w * 1.1 : 360}px`,
          height: `auto`,
        });

        $(".popupVideo>.detail").fadeIn("100");
      } else if (per_max > 85) {
        $(".popupVideo").css({
          top: pos.top + h / 2,
          left: w_device - 360/2 - (w_device * 0.04),
          width: `${w * 1.1 > 360 ? w * 1.1 : 360}px`,
          height: `auto`,
        });
        $(".popupVideo>.detail").fadeIn("100");
      } else {
        $(".popupVideo>.detail").hide();
        $(".popupVideo>.detail").fadeIn("100");
      }
    },
    [handlePopupChange, viewType, w_device]
  );

  let handleMouseEnter: any = () => {}
  if (w_device >= 1200) {
    handleMouseEnter = handleImageMouseEnter
  }

  return (
    <div className="p-3">
      <img
        src={content.thumb}
        onClick={() => {goToPage(`/ondemand/detail/${content.id}`, content)}}
        alt=""
        onMouseEnter={handleMouseEnter}
      />
    </div>
  );
}

async function fetchShelf(shelf:string) {
  const host = getHost()
  return axios.get(`${host}/api/series-category-shelf/${shelf}`);
}

async function fetchLoadmoreContents(shelf:string, cursor:string) {
  const host = getHost()
  return axios.get(`${host}/api/series-category-shelf/${shelf}?cursor=${cursor}`);
}

export default Subcategory;
